export const RATE_FIELDS = [
  { key: 'card_approval_rate', label: '카드승인', defaultValue: '0.86' },
  { key: 'phone_approval_rate', label: '전화승인', defaultValue: '0.86' },
  { key: 'deposit_rate', label: '입금', defaultValue: '0.90' },
];

export const COMPANY_FEATURES = [
  { key: 'attendance', label: '출퇴근' },
  { key: 'leave', label: '연차' },
  { key: 'call', label: '일일콜', defaultOn: true },
  { key: 'revenue', label: '매출관리' },
  { key: 'settlement', label: '정산서관리' },
  { key: 'incentive', label: '인센티브' },
  { key: 'terminal_management', label: '단말기관리' },
];

export function isCompanyFeatureOn(features = {}, feature) {
  if (feature.key === 'call') return features.call !== false;
  return Boolean(features[feature.key]);
}
